import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {HMSRoomProvider} from '@100mslive/react-sdk';
import {FeatureFlags} from './services/100-ms-services/FeatureFlags';
import {AppContextProvider} from './100-ms-integration/context/AppContext';
import {ToastContainer} from './100-ms-integration/Toast/ToastContainer';
import {Notifications} from './100-ms-integration/Notifications';
import { HMSThemeProvider } from '@100mslive/react-ui';
import {getThemeData} from '../src/ThemeComponents/ThemeUtiles'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const envPolicyConfig = JSON.parse(process.env.REACT_APP_POLICY_CONFIG || '{}');
const themeConfig= {
  aspectRatio: process.env.REACT_APP_TILE_SHAPE as any,
  font: process.env.REACT_APP_FONT as any,
  color: process.env.REACT_APP_COLOR as any,
  theme: process.env.REACT_APP_THEME as any,
  logo: process.env.REACT_APP_LOGO as any,
  headerPresent: process.env.REACT_APP_HEADER_PRESENT as any,
  metadata: process.env.REACT_APP_DEFAULT_APP_DETAILS as any, // A stringified object in env,
  //recordingUrl: any,
};

const { 0: width, 1: height } = themeConfig.aspectRatio
  .split("-").map((el: any) => parseInt(el));

// TODO: remove now that there are options to change to portrait
const getAspectRatio = (width: any, height: any) => {
  const host = process.env.REACT_APP_HOST_NAME || window.location.hostname;
  const portraitDomains = (
    process.env.REACT_APP_PORTRAIT_MODE_DOMAINS || ""
  ).split(",");
  if (portraitDomains.includes(host) && width > height) {
    return { width: height, height: width };
  }
  return { width, height };
};

root.render(
  <React.StrictMode>
    <HMSThemeProvider
      themeType={themeConfig.theme}
      aspectRatio={getAspectRatio(width, height)}
      theme={getThemeData(themeConfig.color, themeConfig?.font)}
    >
      <HMSRoomProvider isHMSStatsOn={FeatureFlags.enableStatsForNerds}>
        <AppContextProvider
          policyConfig={envPolicyConfig}
          appDetails={process.env.REACT_APP_DEFAULT_APP_DETAILS}
          // logo={LogoForDark}
        >
          <ToastContainer />
          <Notifications />
          <App />
        </AppContextProvider>
      </HMSRoomProvider>
    </HMSThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
